import { createClient, type SupabaseClient as RawSupabaseClient } from '@supabase/supabase-js';

/**
 * Re-exported untyped SupabaseClient. We don't thread a Database generic
 * because hand-rolled `Database` interfaces don't satisfy supabase-js v2's
 * `GenericSchema` constraints reliably; the auto-generated types from
 * `supabase gen types typescript` would, but we don't ship them yet.
 *
 * Read-side type safety is achieved by casting `select()` results to the
 * Row interfaces in `./types`. Write-side correctness is enforced by RLS
 * and the `0003_html_sanitize_trigger.sql` defence-in-depth migration.
 */
export type SupabaseClient = RawSupabaseClient;

export function createSupabaseClient(url: string, anonKey: string): SupabaseClient {
  if (!url || !anonKey) {
    throw new Error('createSupabaseClient: missing Supabase URL or anon key');
  }
  return createClient(url, anonKey, {
    auth: {
      flowType: 'pkce',
      autoRefreshToken: true,
      persistSession: true,
      detectSessionInUrl: true,
    },
  });
}
